import { useQuery } from 'react-query';
import axios from '../utils/axios-util';

const DashboardListData = (customer) => {
  return axios({
    url: `/dashboards/${customer}`,
    method: 'get'
  });
};

const useGetDashboardListData = (customer) => {
  return useQuery(["dashboardData", customer], () => DashboardListData(customer), {
    enabled: !!customer
  });
};

export default useGetDashboardListData;
